import React from "react";
import {
  Layout,
  Card,
  FormLayout,
  PageActions,
  SkeletonBodyText,
  Page,
} from "@shopify/polaris";
import { TitleBar } from "@shopify/app-bridge-react";
import { useTranslation } from "react-i18next";

export default function MapSettingsSkeleton(props) {
  const { t } = useTranslation();
  
  return (
    <Page>
      <TitleBar title={t("settings.map.title")} actionGroups={[]} />
      <Layout>
        <Layout.AnnotatedSection
          title={t("settings.map.mapboxToken.title")}
          description={t("settings.map.mapboxToken.description")}
        >
          <Card>
            <Card.Section>
              <SkeletonBodyText />
            </Card.Section>
          </Card>
        </Layout.AnnotatedSection>

        <Layout.AnnotatedSection
          title={t("settings.map.searchBehaviour.title")}
          description={t("settings.map.searchBehaviour.description")}
        >
          <Card>
            <Card.Section>
              <FormLayout>
                <SkeletonBodyText />
              </FormLayout>
            </Card.Section>
            <Card.Section>
              <FormLayout>
                <SkeletonBodyText />
              </FormLayout>
            </Card.Section>
          </Card>
        </Layout.AnnotatedSection>

        <Layout.AnnotatedSection
          title={t("settings.map.searchResults.title")}
          description={t("settings.map.searchResults.description")}
        >
          <Card sectioned>
            <FormLayout>
              <SkeletonBodyText />
              <SkeletonBodyText />
              <SkeletonBodyText />
              <FormLayout.Group>
                <SkeletonBodyText />
                <SkeletonBodyText />
              </FormLayout.Group>
            </FormLayout>
          </Card>
        </Layout.AnnotatedSection>

        {/* <Layout.AnnotatedSection
          title="Markers"
          description="Shopify and your customers will use this information to contact you."
        >
          <Card sectioned>
            <FormLayout>
              <ChoiceList
                title="Location marker image"
                choices={[
                  { label: "Use the theme marker", value: "theme" },
                  { label: "Use my own image", value: "own" },
                ]}
                selected={"theme"}
                onChange={() => {}}
                disabled
              />
              <ChoiceList
                title="Search marker image"
                choices={[
                  { label: "Use the theme marker", value: "theme" },
                  { label: "Use my own image", value: "own" },
                ]}
                selected={"theme"}
                onChange={() => {}}
                disabled
              />
            </FormLayout>
          </Card>
        </Layout.AnnotatedSection> */}

        {/* <Layout.AnnotatedSection title="Formats" description="">
          <Card sectioned>
            <FormLayout>
              <ChoiceList
                title="Time format"
                choices={[
                  { label: "24H", value: "24" },
                  { label: "12H", value: "12" },
                ]}
                selected={shop_setting.time_format}
                onChange={(value) => handleUpdate("time_format", value[0])}
              />
            </FormLayout>
          </Card>
        </Layout.AnnotatedSection> */}

        <Layout.AnnotatedSection title={t("settings.map.popups.title")} description="">
          <Card sectioned>
            <FormLayout>
              <SkeletonBodyText />
            </FormLayout>
          </Card>
        </Layout.AnnotatedSection>

        <Layout.AnnotatedSection title={t("settings.map.whitelabel.title")} description="">
          <Card sectioned>
            <FormLayout>
              <SkeletonBodyText />
            </FormLayout>
          </Card>
        </Layout.AnnotatedSection>
      </Layout>
    </Page>
  );
}
